import React from 'react'

const DS_With_Python = () => {
  return (
    <div>
        {/* collapseFiftyOne */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingFiftyOne">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFiftyOne" aria-expanded="false" aria-controls="collapseFiftyOne">
                    Data Science With Python
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseFiftyOne" className="accordion-collapse collapse" aria-labelledby="headingFiftyOne" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Module 1: Introduction to Python</strong>
                    <strong>Introduction to Python</strong>
                    <ul>
                        <li>What is Python?</li>
                        <li>Why Python?</li>
                        <li>Installing Python</li>
                        <li>Python IDEs</li>
                        <li>Jupyter Notebook Overview</li>
                    </ul>
                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Installing Python idle for windows, Linux</li>
                        <li>Creating "Hello World" code</li>
                    </ul>
                    
                    <strong>Module 2: Python Basics</strong>
                    <ul>
                        <li>Python Basic Data Types</li>
                        <li>Lists</li>
                        <li>Slicing</li>
                        <li>If Statements</li>
                        <li>Loops</li>
                        <li>Dictionaries</li>
                        <li>Tuples</li>
                        <li>Functions</li>
                        <li>Array</li>
                        <li>Selection by Position & Labels</li>
                    </ul>

                    <strong>Hands-on-Exercise-Constructing Operators</strong>
                    <ul>
                        <li>Practice and Quickly learn Python necessary skills by solving simple questions and problems.</li>
                        <li>how Python uses indentation to structure a program, and how to avoid some common indentation errors.</li>
                        <li>You executed to make simple numerical lists, as well as a few operations you can perform on numerical lists, tuple, dictionary and set.</li>
                    </ul>

                    <strong>Module 3: Python Packages</strong>
                    <ul>
                        <li>Pandas</li>
                        <li>Numpy</li>
                        <li>Sci-kit Learn</li>
                        <li>Mat-plot library</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>Installing jupyter notebook for windows, Linux and Installing numpy, pandas and matplotlib</li>
                    </ul>

                    <strong>Module 4: Importing Data</strong>
                    <ul>
                        <li>Reading CSV files</li>
                        <li>Saving in Python data</li>
                        <li>Loading Python data objects</li>
                        <li>Writing data to CSV file</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>To generate data sets and create visualizations of that data. You learned to create simple plots with matplotlib, and you saw how to use a scatter plot to explore random</li>
                        <li>You learned to create a histogram with Pygal and how to use a histogram to explore the results of rolling dice of different</li>
                        <li>Generating your own data sets with code is an interesting and powerful way to model and explore a wide variety of real-world</li>
                        <li>As you continue to work through the data visualization projects that follow</li>
                    </ul>

                    <strong>Module 5: Manipulating Data</strong>
                    <ul>
                        <li>Selecting rows/observations</li>
                        <li>Rounding Number</li>
                        <li>Selecting columns/fields</li>
                        <li>Merging data</li>
                        <li>Data aggregation</li>
                        <li>Data munging techniques</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>As you gain experience with CSV and JSON files, you’ll be able to process almost any data you want to analyze.</li>
                        <li>Most online data sets can be downloaded in either or both of these. From working with these formats, you’ll be able to learn other data formats as well.</li>
                    </ul>

                    <strong>Module 6: Error Metrics</strong><br/>
                    <strong>Classification</strong>
                    <ul>
                        <li>Confusion Matrix</li>
                        <li>Precision</li>
                        <li>Recall</li>
                        <li>Specificity</li>
                        <li>F1 Score</li>
                    </ul>

                    <strong>Regression</strong>
                    <ul>
                        <li>MSE</li>
                        <li>RMSE</li>
                        <li>MAPE</li>
                    </ul>

                    <strong>Hands-on-Exercise:</strong>
                    <ul>
                        <li>State why the z’ transformation is necessary</li>
                        <li>Compute the standard error of z</li>
                        <li>Compute a confidence interval on z — the computation of a confidence interval</li>
                        <li>Estimate the population proportion from sample proportions</li>
                        <li>Apply the correction for continuity</li>
                    </ul>





                </div>
            </div>
        </div>

    </div>
  )
}

export default DS_With_Python